import { configureStore, ThunkAction, Action, combineReducers } from '@reduxjs/toolkit';
import { persistStore, FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER } from 'redux-persist';
import langReducer from './reducers/headerSlice';
import countryReducer from './reducers/countrySlice';
import menuReducer from './reducers/menuSlice';
import cartReducer from './reducers/cartSlice';
import noticeReducer from './reducers/noticeSlice';
import companyReducer from './reducers/companySlice';
import planReducer from './reducers/planSlice';
import searchReducer from './reducers/searchSlice';
import appReducer from './reducers/appReducer';
// import classifyAndCountryReducer from './reducers/classifyAndCountryReducer';

const rootReducer = combineReducers({
  lang: langReducer,
  country: countryReducer, // country
  menus: menuReducer, // menus
  cart: cartReducer, // cart
  notice: noticeReducer, // notice
  company: companyReducer, // company
  plan: planReducer, // plan
  search: searchReducer,
  app: appReducer,
  // classifyandcountry: classifyAndCountryReducer
});

export const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) => getDefaultMiddleware({ serializableCheck: { ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER] }, immutableCheck: { warnAfter: 128 } }),
  devTools: process.env.NODE_ENV !== 'production',
});

export const persistor = persistStore(store);

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
export type AppThunk<ReturnType = void> = ThunkAction<
  ReturnType,
  RootState,
  unknown,
  Action<string>
>;